import { render, staticRenderFns } from "./CreateEditAddress.vue?vue&type=template&id=1cf4a1a2&"
import script from "./CreateEditAddress.vue?vue&type=script&lang=js&"
export * from "./CreateEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports